<template>
    <div class="w-full h-full">
        <FormModal v-if="showFilters" @cancel="showFilters = false; offerType = []; retailerCategory = undefined"
            @confirm="showFilters = false; getActiveCampaigns(0, 50)" :valid="true" title="Filter results"
            subtitle="Select from these filters to refine your search" submitButtonText="Apply filters">
            <div class="grid gap-3">
                <CustomCheckbox v-model="offerType" :options="offerTypes" label="Select campagin status:" />
            </div>
        </FormModal>
        <Header title="Tenancy Campaigns" icon="Presentation" />
        <WhiteBox title="Your campaigns" subText="Manage and view your tenancy campaigns">
            <template v-slot:buttons>
                <CustomButton small text="Filter results" type="action" icon="Filter" @click="showFilters = !showFilters">
                </CustomButton>
                <CustomButton small text="Create campaign" type="navigate" icon="Plus"
                    @click="$router.push(`/campaign-builder`)">
                </CustomButton>
            </template>

            <template v-slot:content>
                <!-- <div class="grid mt-6">
                    <SearchBar placeholderText="Search by retailer name" @search="(val) => getRetailerBySearch(0,50,val)">
                        <CustomButton small text="" type="default" icon="X" @click="getProgramOffers(0,25)" />
                    </SearchBar>
                </div> -->
                <div v-if="offerType && offerType.length > 0 " class="flex justify-start items-center gap-2 mb-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Applied filters:</p>
                    <div  class="flex justify-start items-center py-1 gap-1">
                        <div v-for="offer,index in offerType" :key="index">
                        <StatusPill
                        :text="offer.text"
                        :colour="'blue'"
                        />
                    </div>
     
                        
                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min"
                        >

                        <p class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer" @click="offerType = [{ id: 'INPROGRESS', text: 'Active' },{ id: 'PENDING', text: 'Pending' },]; getActiveCampaigns(0, 50)">Clear filters</p>
                        </div>
                    </div>
                </div>

                <EasyDataTable :headers="headersTable2" :items="activeCampaigns" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-activate="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-campaign="campaign">
                        <div class="flex justify-start items-center py-2 gap-2 font-medium">
                            <img v-if="campaign.campaign.slot != 'PROMOTED'" class="w-8 h-8 rounded-md border border-gray-200" :src="campaign.campaign.assetLink" />
                            <LucideIcon v-else name="Megaphone" :size="36" :stroke-width="1.7"  />
                            {{ campaign.campaign.name }}
                        </div>
                    </template>
                    <template #item-retailer="audiences">
                        <!-- {{ campaign }} -->
                        <LogoAndText 
                            :logo="audiences.campaign.retailer.logo"
                            :text="audiences.campaign.retailer.retailerName"
                        />
                    </template>
                    <template #item-audiences="audiences">
                        <!-- {{ campaign }} -->
                        <div v-for="audience,id in audiences.campaign.associatedAudiences" :key="id" >
                           <p> {{ audience.name }} </p>
                        </div>
                    </template>
                    <template #item-cashback="campaign">
 
                        <CashbackPill v-if="campaign.programOffer != null" :text="campaign.programOffer.displayRules[0].highestCashbackPercentageAmount"
                            :type="campaign.programOffer.cashbackEarnings[0].conditions[0].value.type"
                            :currency="campaign.programOffer.offer.currency" />
                        
                            <p v-else>> Offer has been removed from program</p>

                    </template>

                    <template #item-startDate="campaign">
                        <div class="flex items-center py-1 gap-1">
                            {{ niceDateTime(campaign.campaign.startDate) }}
                        </div>
                    </template>

                    <template #item-slot="campaign">
                        <div class="flex items-center py-1 gap-1">
                            <StatusPill
                        :text="campaign.campaign.slot"
                        :colour="'blue'"
                        />
                        </div>
                    </template>


                    <template #item-status="campaign">
                        <div class="flex items-center py-1 gap-1">
                            <StatusPill
                        :text="campaign.campaign.campaignStatus"
                        :colour="'blue'"
                        />
                        </div>
                    </template>

                    <template #item-endDate="campaign">
                        <div class="flex items-center py-1 gap-1">
                            {{ niceDateTime(campaign.campaign.endDate) }}
                        </div>
                    </template>

                    <template #item-action="audience">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton  type="navigate" v-if="audience.programOffer != null" small text="View offer"
                            @click="$router.push(`/retailer/${audience.programOffer.retailer.id}/offer/${audience.programOffer.offer.id}`)"
                            icon="View" />
                            <CustomButton small text="" @click="deleteCampaign(audience.campaign.id)"
                                icon="Trash2" type="warning" />
                        </div>
                    </template>

                    <!-- <template #item-date="retailers">
                        <div class="flex justify-end items-center py-1 gap-1">
                            {{ niceDateTime(retailers.createdOn) }}
                        </div>
                    </template> -->



                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
// import SearchBar from '@/components/SearchBar.vue'

import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import { DateTime } from 'luxon';
import CashbackPill from "@/components/CashbackPill.vue";
import FormModal from "@/components/modals/FormModal.vue";
import CustomCheckbox from "@/components/inputs/CustomCheckbox.vue";
import StatusPill from "@/components/StatusPill.vue";
import LogoAndText from "@/components/LogoAndText.vue";
import LucideIcon from "@/components/LucideIcon.vue";

export default {
    name: "campaigns-page",
    components: {
        Header,
        WhiteBox,
        CustomButton,
        FormModal,
        CustomCheckbox,
        StatusPill,
        LogoAndText,
        CashbackPill,
        LucideIcon
    },
    props: {
    },

    data() {
        return {
            serverOptions: {
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength: undefined,
            serverOptions2: {
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength2: undefined,
            loading: true,
            loading2: true,
            showFilters: false,


            headersTable2: [
                { text: "Campaign", value: "campaign" },
                { text: "Retailer", value: "retailer" },
                { text: "Slot", value: "slot" },

                { text: "Cashback", value: "cashback" },
                { text: "Status", value: "status" },
                { text: "Audience", value: "audiences" },
                { text: "StartDate", value: "startDate" },
                { text: "EndDate", value: "endDate" },
                { text: "Action", value: "action" },
            ],

            activeCampaigns: [],
            pendingCampaigns: [],
            orderByList: [
                { "id": "MOSTPOPULAR", "text": "Most Popular" },
                { "id": "ATOZ", "text": "A to Z" },
                { "id": "ZTOA", "text": "Z to A" }
            ],
            offerTypes: [
                { id: "INPROGRESS", text: 'In Progress' },
                { id: "PENDING", text: 'Pending' },
                { id: "CLOSED", text: 'Closed' },
            ],

            offerType: [
            { id: "INPROGRESS", text: 'In Progress' },
            { id: "PENDING", text: 'Pending' },
            ],
        }
    },
    created() {
        this.getActiveCampaigns(0, 25)

    },
    methods: {

        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
        },

        async deleteCampaign(id) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/campaign/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                        this.getActiveCampaigns(0, 50)
                }


            } catch (error) {
                console.log(error)
                return;
            }

        },

        async getActiveCampaigns(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                if(this.offerType.length > 0)
                {var offerType = []
                this.offerType.forEach(element => {
                    offerType.push(element.id)
                });
            }

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/campaign${this.offerType.length > 0  ? '?status='+offerType : '' }&page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.activeCampaigns = object.content

                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },



    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Campaigns";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getActiveCampaigns(val.page - 1, val.rowsPerPage)
            }
        },
        serverOptions2: {
            deep: true,
            handler(val) {
                this.getDeclinedOffers(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>